import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  BookingChatCreate,
  BookingCreateSubscription,
  onUpdateBookings,
  updateChats,
} from "../slices/bookingSlice"
const useSubToEvents = () => {
  const dispatch = useDispatch()
  const userId = useSelector(state => state.user?.data?.id)

  const onUpdateChat = newChat => {
    // console.log("New chat:", newChat)
    dispatch(BookingChatCreate({ ...newChat }))
  }

  const onUpdateBooking = newBooking => {
    // console.log("New chat:", newChat)
    // dispatch(BookingChatCreate({ ...newChat }))
  }

  useEffect(() => {
    if (!userId) return
    let unsubscribeChat
    let unsubscribeCreateBooking
    let unsubscribeUpdateBooking

    const subscribeAndUpdateChats = async () => {
      try {
        const resultAction = await dispatch(
          updateChats({
            to: userId,
            onUpdate: onUpdateChat,
          })
        )

        if (resultAction?.payload?._cleanup) {
          unsubscribeChat = resultAction.payload._cleanup
        } else {
          console.error("Failed to subscribe to updateChats:")
        }
      } catch (err) {
        console.error("Failed to dispatch updateChats:", err)
      }
    }

    const subscribeCreateBookings = async () => {
      try {
        const resultAction = await dispatch(
          BookingCreateSubscription({
            to: userId,
            // onUpdate: onUpdateChat,
          })
        )

        if (resultAction?.payload?._cleanup) {
          unsubscribeCreateBooking = resultAction.payload._cleanup
        } else {
          console.error("Failed to subscribe to updateChats:")
        }
      } catch (err) {
        console.error("Failed to dispatch updateChats:", err)
      }
    }

    const subscribeUpdateBookings = async () => {
      try {
        const resultAction = await dispatch(
          onUpdateBookings({
            owner: userId,
            // onUpdate: onUpdateChat,
          })
        )

        if (resultAction?.payload?._cleanup) {
          unsubscribeUpdateBooking = resultAction.payload._cleanup
        } else {
          console.error("Failed to subscribe to updateChats:")
        }
      } catch (err) {
        console.error("Failed to dispatch updateChats:", err)
      }
    }

    subscribeAndUpdateChats()
    subscribeCreateBookings()
    subscribeUpdateBookings()

    return () => {
      if (unsubscribeChat) {
        unsubscribeChat()
      }
      if (unsubscribeUpdateBooking) {
        unsubscribeUpdateBooking()
      }
    }
  }, [dispatch, userId, onUpdateChat])

  return
}

export default useSubToEvents
